<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';
import { useStore } from 'vuex';

import { ShippingOffer } from '@/api/shippingCalculator';
import RadioGroup from '@/components/base/form/RadioGroup.vue';
import ShippingOfferComponent from '@/components/checkout/steps/delivery/ShippingOffer.vue';
import { useDelivery } from '@/composables/useDelivery';

const props = defineProps<{
  addressKey: string;
  modelValue?: ShippingOffer;
  shippingOffers: ShippingOffer[];
}>();

const emit = defineEmits<{ 'update:modelValue': [ShippingOffer | undefined] }>();

const store = useStore();
const { isPickup } = useDelivery(store);

const selectedShippingOffer = useVModel(props, 'modelValue', emit);

const selectedShippingOfferId = computed(
  (): number | undefined => selectedShippingOffer.value?.shippingMethodId ?? undefined,
);
</script>

<template>
  <div aria-label="Delivery Offer Radio Options" data-test="delivery-offer-list" role="radiogroup">
    <RadioGroup
      v-model="selectedShippingOffer"
      class="font-normal"
      data-test="delivery-offer-radio-input"
      :items="shippingOffers"
      :keyGetter="(shipping) => shipping.shippingMethodId"
      :name="`${addressKey}-delivery-offer-list`"
      :valueGetter="(shipping) => shipping"
    >
      <template #default="{ item }">
        <ShippingOfferComponent
          class="w-full"
          :highlight="selectedShippingOfferId === item.shippingMethodId"
          :isPickup="isPickup"
          :shippingOffer="item"
        />
      </template>
    </RadioGroup>
  </div>
</template>
